import React from 'react'
import {Svg} from '@modifi/ui'

export default ({...props}) => (
  <Svg viewBox="0 0 150 150" {...props}>
    <defs>
      <path id="bpm-a" d="M0 6V0h6v6H0zm2.59-1.252h.82V1.252h-.82v3.496z" />
      <path
        id="bpm-c"
        d="M0 6V0h6v6H0zm1.718-4.748v3.496h.822V3.613h1.512V2.79H2.54v-.717h1.823v-.822H1.718z"
      />
      <path id="bpm-e" d="M0 6V0h6v6H0zm2.59-1.252h.82V1.252h-.82v3.496z" />
      <path
        id="bpm-g"
        d="M0 6V0h6v6H0zm1.425-4.748v3.496h1.403a1.748 1.748 0 1 0 0-3.496H1.425zM3.753 3a.926.926 0 0 1-.925.926h-.581V2.074h.58c.512 0 .926.415.926.926z"
      />
      <path
        id="bpm-i"
        d="M0 6V0h6v6H0zm2.993-4.787c-1 0-1.81.805-1.81 1.799 0 .993.81 1.798 1.81 1.798s1.81-.805 1.81-1.798c0-.994-.81-1.799-1.81-1.799zm0 2.782a.987.987 0 0 1-.99-.983c0-.544.444-.984.99-.984.547 0 .99.44.99.984a.987.987 0 0 1-.99.983z"
      />
      <path
        id="bpm-k"
        d="M0 6V0h6v6H0zm3.803-4.748L3 3.518l-.803-2.266H1.162v3.496h.822V3.11l.58 1.637h.872l.58-1.637v1.637h.822V1.252H3.803z"
      />
    </defs>
    <g fill="none" fillRule="evenodd">
      <g transform="translate(61 48)">
        <path fill="#FFF" stroke="#51565C" strokeWidth="3.5" d="M.48 0h79.78v52.075H.48z" />
        <path fill="#FFF" stroke="#51565C" strokeWidth="3.5" d="M55.58 20.113h28v16.12h-28z" />
        <ellipse cx="64.264" cy="28.503" fill="#51565C" rx="2.5" ry="2.466" />
        <path stroke="#51565C" strokeWidth="3.5" d="M2.203 10.755h76.519" />
        <g transform="translate(44.139 26.038)">
          <mask id="bpm-b" fill="#fff">
            <use href="#bpm-a" />
          </mask>
          <use fill="#1251A0" href="#bpm-a" />
          <g fill="#15539F" mask="url(#bpm-b)">
            <path d="M0 0h6v6H0z" />
          </g>
        </g>
        <g transform="translate(38.277 26.038)">
          <mask id="bpm-d" fill="#fff">
            <use href="#bpm-c" />
          </mask>
          <use fill="#1251A0" href="#bpm-c" />
          <g fill="#15539F" mask="url(#bpm-d)">
            <path d="M0 0h6v6H0z" />
          </g>
        </g>
        <g transform="translate(32.415 26.038)">
          <mask id="bpm-f" fill="#fff">
            <use href="#bpm-e" />
          </mask>
          <use fill="#1251A0" href="#bpm-e" />
          <g fill="#7BB835" mask="url(#bpm-f)">
            <path d="M0 0h6v6H0z" />
          </g>
        </g>
        <g transform="translate(26.553 26.038)">
          <mask id="bpm-h" fill="#fff">
            <use href="#bpm-g" />
          </mask>
          <use fill="#7BB934" href="#bpm-g" />
          <g fill="#7BB835" mask="url(#bpm-h)">
            <path d="M0 0h6v6H0z" />
          </g>
        </g>
        <g transform="translate(20.691 26.038)">
          <mask id="bpm-j" fill="#fff">
            <use href="#bpm-i" />
          </mask>
          <use fill="#51A2DA" href="#bpm-i" />
          <g fill="#53A2D9" mask="url(#bpm-j)">
            <path d="M0 0h6v6H0z" />
          </g>
        </g>
        <g transform="translate(14.83 26.038)">
          <mask id="bpm-l" fill="#fff">
            <use href="#bpm-k" />
          </mask>
          <use fill="#51A2DA" href="#bpm-k" />
          <g fill="#53A2D9" mask="url(#bpm-l)">
            <path d="M0 0h6v6H0z" />
          </g>
        </g>
      </g>
      <path
        fill="#51565C"
        fillRule="nonzero"
        stroke="#FFF"
        strokeWidth="2"
        d="M75.235 74.434l-7.54-8.32 3.629-3.243 11.225 12.386a2.418 2.418 0 0 1 0 3.25L71.324 90.895l-3.629-3.243 7.088-7.82h-31.52v-5.397h31.972z"
      />
      <path
        fill="#15539F"
        stroke="#FFF"
        strokeWidth="3"
        d="M18.007 42.462h28.828v28.472H18.007V42.462z"
      />
      <path
        fill="#FFF"
        d="M33.567 59.798c.964 0 1.777-.376 2.438-1.128l1.419 1.304a4.472 4.472 0 0 1-1.702 1.264c-.675.29-1.43.434-2.266.434-.799 0-1.54-.14-2.224-.42a4.843 4.843 0 0 1-1.743-1.196 4.632 4.632 0 0 1-1.033-1.793H26.9v-1.141h1.35a3.572 3.572 0 0 1-.014-.367c0-.163.004-.286.014-.367H26.9v-1.141h1.556a4.632 4.632 0 0 1 1.033-1.793 4.843 4.843 0 0 1 1.743-1.196 5.803 5.803 0 0 1 2.224-.421c.836 0 1.591.145 2.266.435.675.29 1.242.706 1.702 1.25l-1.42 1.304c-.67-.743-1.482-1.114-2.437-1.114-.606 0-1.148.136-1.626.407a2.79 2.79 0 0 0-1.102 1.128h3.485v1.14h-3.83c-.008.082-.013.205-.013.368s.005.285.014.367h3.83v1.14h-3.486c.257.48.625.856 1.102 1.128.478.272 1.02.408 1.626.408z"
      />
      <path fill="#7BB835" stroke="#FFF" strokeWidth="3" d="M3.5 63.783h28.844V92.27H3.5V63.783z" />
      <path
        fill="#FFF"
        d="M19.06 81.118c.964 0 1.777-.375 2.438-1.127l1.419 1.304a4.472 4.472 0 0 1-1.702 1.263c-.675.29-1.43.435-2.266.435-.799 0-1.54-.14-2.224-.42a4.843 4.843 0 0 1-1.743-1.196 4.632 4.632 0 0 1-1.033-1.794h-1.556v-1.14h1.35a3.572 3.572 0 0 1-.014-.368c0-.163.004-.285.013-.366h-1.35v-1.141h1.557a4.632 4.632 0 0 1 1.033-1.794 4.843 4.843 0 0 1 1.743-1.195 5.803 5.803 0 0 1 2.224-.421c.836 0 1.591.145 2.266.434.675.29 1.242.707 1.702 1.25l-1.42 1.304c-.67-.742-1.482-1.114-2.437-1.114-.607 0-1.148.136-1.626.408a2.79 2.79 0 0 0-1.102 1.128h3.485v1.14h-3.83c-.008.082-.013.204-.013.367s.005.286.014.367h3.83v1.141h-3.486c.257.48.625.856 1.102 1.128.478.272 1.02.407 1.626.407z"
      />
      <g>
        <path
          fill="#53A2D9"
          stroke="#FFF"
          strokeWidth="3"
          d="M24.468 80.406h28.828v28.472H24.468z"
        />
        <path
          fill="#FFF"
          d="M40.602 98.307c.964 0 1.777-.376 2.438-1.127l1.419 1.304a4.472 4.472 0 0 1-1.701 1.263c-.675.29-1.43.435-2.266.435-.8 0-1.54-.14-2.225-.421a4.843 4.843 0 0 1-1.742-1.196 4.632 4.632 0 0 1-1.033-1.793h-1.557v-1.141h1.35a3.572 3.572 0 0 1-.014-.367c0-.163.005-.285.014-.367h-1.35v-1.14h1.557a4.632 4.632 0 0 1 1.033-1.794 4.843 4.843 0 0 1 1.742-1.195 5.803 5.803 0 0 1 2.225-.422c.835 0 1.59.145 2.266.435.675.29 1.242.707 1.701 1.25l-1.419 1.304c-.67-.743-1.483-1.114-2.438-1.114-.606 0-1.148.136-1.625.408a2.79 2.79 0 0 0-1.102 1.127h3.485v1.141h-3.83c-.009.082-.014.204-.014.367s.005.285.014.367h3.83v1.141h-3.485c.257.48.624.856 1.102 1.128.477.271 1.019.407 1.625.407z"
        />
      </g>
    </g>
  </Svg>
)
